// Gọi 1 hàm rpc_* của Supabase (PostgREST) bằng fetch — đo được tổng thời gian + byte, đọc đúng chữ lỗi
// tiếng Việt do hàm plpgsql `raise exception` trả về. Dùng cho đường GHI (P4); đường đọc ở duLieuLop.ts.
import { type KetQua, thanhCong, thatBai } from "./ketQua";
import { supabase } from "./supabaseClient";

const URL_GOC = (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "";
const ANON = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? "";

export async function goiRpc<T>(ten: string, body: Record<string, unknown>): Promise<KetQua<T> & { ms: number }> {
  const t0 = performance.now();
  const xong = <R extends KetQua<T>>(k: R) => ({ ...k, ms: performance.now() - t0 });
  try {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) return xong(thatBai("Phiên đăng nhập đã hết — tải lại trang để đăng nhập lại"));
    const res = await fetch(`${URL_GOC}/rest/v1/rpc/${ten}`, {
      method: "POST",
      headers: { apikey: ANON, Authorization: `Bearer ${token}`, "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    const text = await res.text();
    if (!res.ok) {
      let msg = text;
      try { msg = (JSON.parse(text) as { message?: string }).message ?? text; } catch { /* giữ nguyên chữ */ }
      return xong(thatBai(msg || `${ten} lỗi ${res.status}`));
    }
    return xong(thanhCong(JSON.parse(text) as T));
  } catch (e) {
    return xong(thatBai(e instanceof TypeError ? "Mất kết nối mạng — chưa lưu được, thử lại." : e));
  }
}
